/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'

function calculateSearchElementsPerRow(containerWidth = 1280) {
  return Math.floor(containerWidth > 1280 ? 1280 / 197 : containerWidth / 197)
}

export default (isMobile: any) => {
  const [visualViewport, setVisualViewport] = useState(
    window?.visualViewport?.width
  )
  const [isScrollbarVisible, setIsScrollbarVisible] = useState(false)
  const [searchViewElementsPerRow, setSearchViewElementsPerRow] = useState(() =>
    calculateSearchElementsPerRow(visualViewport)
  )
  useEffect(() => {
    if (isMobile || !window?.visualViewport?.width) {
      return undefined
    }

    const handleResize = () => {
      setSearchViewElementsPerRow(
        calculateSearchElementsPerRow(window?.visualViewport?.width)
      )
      setVisualViewport(window?.visualViewport?.width)
    }
    window.visualViewport.addEventListener('resize', handleResize)
    return () =>
      window?.visualViewport?.removeEventListener('resize', handleResize)
  }, [isMobile])

  useEffect(() => {
    if (isMobile || !window?.visualViewport?.width) {
      setIsScrollbarVisible(false)
      return
    }
    setIsScrollbarVisible(window.innerWidth > (visualViewport || 0))
  }, [isMobile, visualViewport])

  // in quicksilver visualViewport is not event sent. I marked as undefined for type consistency
  return {
    isScrollbarVisible,
    searchViewElementsPerRow,
    visualViewport: undefined,
  }
}
